<template dark>
  <div class="renderPage reporte-container animate-fade-in">
    <!-- Main Toolbar -->
    <v-toolbar color="primary" dark flat class="mb-6 rounded-xl" height="64">
      <v-icon class="mr-3" size="28">mdi-account-edit-outline</v-icon>
      <v-toolbar-title class="text-subtitle-1 text-sm-h6 font-weight-black px-0 text-uppercase letter-spacing-1">
        Editar Perfil
      </v-toolbar-title>
      <v-spacer />
      <v-btn icon color="white" @click="close()" class="glass-btn">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-container fluid>
      <v-card class="glass-card rounded-xl overflow-hidden mb-6" elevation="0">
        <div class="px-6 py-4 border-bottom header-glass">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-account-circle</v-icon>
            <span class="text-subtitle-1 font-weight-bold primary--text">Información de Cuenta</span>
          </div>
        </div>

        <v-card-text class="pa-6">
          <v-row align="center">
            <v-col cols="12" sm="3" md="2">
              <v-text-field
                v-model="editedItem.cedula"
                label="Cédula"
                readonly
                class="modern-input"
                outlined
                dense
                rounded
                hide-details="auto"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4" md="4">
              <v-text-field
                :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show3 ? 'text' : 'password'"
                label="Contraseña"
                class="modern-input"
                outlined
                dense
                rounded
                hide-details="auto"
                v-model="editedItem.clave"
                :disabled="incluirValid"
                @click:append="show3 = !show3"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="5" md="4">
              <v-text-field
                v-model="editedItem.nombre"
                label="Nombre Completo"
                :rules="nameRules"
                required
                class="modern-input"
                outlined
                dense
                rounded
                hide-details="auto"
                :disabled="incluirValid"
              ></v-text-field>
            </v-col>
            
            <v-col cols="12" md="2" class="text-center text-md-left mt-4 mt-md-0">
              <v-btn color="success" class="rounded-pill px-8 font-weight-bold shadow-soft w-100" height="46" :disabled="!guardarValid" @click="save()">
                <v-icon left>mdi-content-save</v-icon>
                Guardar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Términos y Condiciones Dialog -->
      <v-dialog v-model="dialogDescargo" max-width="800">
        <v-card class="theme-aware-dialog rounded-xl">
          <v-toolbar color="error" dark flat class="mb-2" height="56">
            <v-icon class="mr-2">mdi-alert-circle</v-icon>
            <v-toolbar-title class="text-subtitle-1 font-weight-bold">
              DESCARGO DE RESPONSABILIDAD
            </v-toolbar-title>
          </v-toolbar>
          
          <v-card-text class="pa-6 text-body-1" style="max-height: 60vh; overflow-y: auto;">
            <p class="mb-4">
              <strong>BestOne Solutions</strong> alquila un sistema de venta de tiempos con el propósito de facilitar las transacciones entre vendedores y banqueros. No obstante, al utilizar este sistema, el usuario reconoce y acepta los siguientes términos y condiciones:
            </p>
            <ol class="pl-4 mb-4" style="line-height: 1.6;">
              <li class="mb-2"><strong>Uso del Sistema:</strong> BestOne Solutions actúa únicamente como proveedor de la plataforma y no interviene en las transacciones realizadas entre las partes. Por lo tanto, no asumimos ninguna responsabilidad por el uso que se haga del sistema, incluyendo cualquier pérdida, fraude o disputa que pudiera surgir.</li>
              <li class="mb-2"><strong>Responsabilidad del Vendedor:</strong> Es exclusiva responsabilidad del vendedor verificar la confiabilidad de su banquero antes de realizar cualquier transacción. BestOne Solutions no se hace responsable por fondos retenidos, pagos no efectuados u otras incidencias derivadas de la relación entre vendedor y banquero.</li>
              <li class="mb-2"><strong>Responsabilidad del Banquero:</strong> Los banqueros deben operar con total transparencia e integridad. En caso de recibir reportes de estafa, fraude o prácticas indebidas, BestOne Solutions se reserva el derecho de deshabilitar de inmediato su acceso al sistema sin previo aviso ni derecho a reclamación.</li>
              <li class="mb-2"><strong>Reportes y Sanciones:</strong> Cualquier usuario que detecte una actividad fraudulenta deberá reportarla de inmediato a BestOne Solutions. Nos reservamos el derecho de investigar dichos reportes y tomar las medidas que consideremos necesarias, incluyendo la suspensión o eliminación de cuentas involucradas.</li>
              <li class="mb-2"><strong>Limitación de Responsabilidad:</strong> BestOne Solutions no será responsable por pérdidas económicas, daños directos o indirectos, ni por cualquier otra consecuencia derivada del uso del sistema. Al acceder y utilizar nuestra plataforma, el usuario acepta liberar a BestOne Solutions de cualquier reclamación o responsabilidad relacionada con transacciones realizadas en el sistema.</li>
            </ol>
            <p class="mb-4 text-center font-weight-bold">
              El uso de este sistema implica la aceptación total de los términos aquí descritos. BestOne Solutions se reserva el derecho de modificar este descargo de responsabilidad en cualquier momento sin previo aviso.
            </p>
            <v-alert dense outlined type="info" class="mb-0 text-center rounded-xl">
              Haga sus reportes al correo: <strong>soportebestone@gmail.com</strong>
            </v-alert>
          </v-card-text>
          
          <v-divider></v-divider>
          <v-card-actions class="pa-4 justify-center">
            <v-btn color="grey darken-1" text class="rounded-pill px-6 font-weight-bold" @click="dialogDescargo = false">
              Cerrar y Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    
    <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Snackbar from "./shared/Snackbar.vue";

export default {
  components: {
    Snackbar,
  },
  dark: true,
  data() {
    return {
      dialog: false,
      show3: false,
      valid: false,
      guardarValid: true,
      snackText: "",
      snackValue: false,
      dialogDescargo: false,
      editedIndex: -1,
      editedItem: {
        id: 0,
        cedula: "",
        clave: "",
        tipo: 0,
        nombre: "",
        ciaPorDefecto: "",
      },
      showNewData: false,
      nameRules: [(v) => !!v || "Campo requerido"],
    };
  },

  computed: {
    ...mapGetters(["user", "strCia"]),
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    search() {
      this.snackValue = false;
    },
  },

  created() {
    this.editedItem = Object.assign({}, this.editedItem);
    this.getData();
  },

  methods: {
    getData() {
      let me = this;
      axios
        .get("api/Usuarios/getUsuario?usuarioId=" + this.user.id, {
          crossdomain: true,
        })
        .then(function (response) {
          me.editedItem = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    openDialogDescargo() {
      this.dialogDescargo = true; // Abre el diálogo
    },

    save() {
      this.openDialogDescargo();
      let me = this;

      axios
        .post("api/Usuarios/updateUser", this.editedItem)
        .then(function () {
          me.snackText = "Registro modificado satisfactoriamente";
          me.snackValue = true;
          me.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.reporte-container {
    padding-bottom: 60px;
}

/* Glassmorphism Styles */
.glass-card {
    background: rgba(255, 255, 255, 0.7) !important;
    backdrop-filter: blur(12px) !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.theme--dark .glass-card {
    background: rgba(30, 30, 46, 0.8) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.glass-btn {
    background: rgba(25, 118, 210, 0.1) !important;
}

.header-glass {
    background: rgba(25, 118, 210, 0.03);
}

.theme--dark .header-glass {
    background: rgba(255, 255, 255, 0.02);
}

.border-bottom {
    border-bottom: 1px solid rgba(0,0,0,0.05);
}

.theme--dark .border-bottom {
    border-bottom: 1px solid rgba(255,255,255,0.05);
}

/* Modern Inputs */
.modern-input >>> .v-input__control > .v-input__slot {
    background: rgba(255, 255, 255, 0.5) !important;
    backdrop-filter: blur(4px);
}

.theme--dark .modern-input >>> .v-input__control > .v-input__slot {
    background: rgba(0, 0, 0, 0.2) !important;
}

/* Text Utilities */
.letter-spacing-1 {
    letter-spacing: 1px;
}

/* Animations */
.animate-fade-in {
    animation: fadeIn 0.4s ease-out;
}

.shadow-soft {
    box-shadow: 0 4px 20px rgba(0,0,0,0.08) !important;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

/* Theme Aware Dialog/Card */
.theme-aware-dialog {
    border-radius: 24px !important;
}

.theme-aware-card {
    background-color: var(--v-background-base, #ffffff) !important;
}

.theme--dark .theme-aware-card {
    background-color: var(--v-background-base, #1e1e2e) !important;
}

/* Legacy Overrides */
.cd {
  overflow: scroll;
}

.v-tabs-items {
  overflow: auto;
}

.botonSalir {
  position: fixed;
  top: 5px;
  right: 5px;
}
</style>